export default {
  USER_INFO_GET_REQUEST: "USER_INFO_GET_REQUEST",
  USER_INFO_GET_RECEIVE: "USER_INFO_GET_RECEIVE",
  USER_INFO_GET_ERROR: "USER_INFO_GET_ERROR",
  USER_INFO_POST_REQUEST: "USER_INFO_POST_REQUEST",
  USER_INFO_POST_RECEIVE: "USER_INFO_POST_RECEIVE",
  USER_INFO_POST_ERROR: "USER_INFO_POST_ERROR",
  UPDATE_SETTINGS_MESSAGE: "UPDATE_SETTINGS_MESSAGE"
};
